import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { media } from '../themes/theme';
import { Card, CardInner, CardShadow } from './shared';
import { CardHeader } from './CardHeader';
import { CardLink } from './CardLink';
const PreviewCardInner = styled.span `
  ${CardInner}
  position: relative;
  background: white;
  display: grid;
  grid-template-rows: auto 1fr auto;
  justify-content: stretch;
  flex-direction: column;
  /**
   * .5rem to offset progress bar which somehow is still part of
   * the parent flex measurements...
   */
  padding: 0.625rem 0.625rem 0.5rem 0.625rem;
  transition: border-radius 0.5s;
  transition-delay: 0.5s;

  /** fixes safari layout height */
  min-height: 0;

  ${props => props.showAction &&
    !props.locking &&
    css `
      border-bottom-right-radius: 3rem;
    `};

  ${media.tablet `
    padding: 1rem 1rem 0.3125rem 1rem;
  `}
`;
const StyledShadow = styled(CardShadow) `
  &::after {
    background: ${props => props.shadowColor || props.theme.CardShadow};
    ${props => props.locking &&
    css `
        animation: ${ShadowAfterAnim(props)} 1.5s ease;
        animation-fill-mode: forwards;
      `}
  }
`;
const ShadowAnim = keyframes `
  33% {
    transform: translate3d(0, 1rem, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
`;
const ShadowAfterAnim = props => keyframes `
  0% {
    height: 99.5%;
    background: ${props.theme.CardShadow};
  }

  50% {
    height: 99.4%;
    background: ${props.theme.CardLockedShadow};
  }

  100% {
    height: 98%;
    background: ${props.theme.CardLockedShadow};
  }
`;
const ActionShadow = styled(StyledShadow) `
  position: absolute;
  z-index: -1;
  top: 0;
  width: 100%;
  height: ${props => (props.shadowContent ? '100.5%' : '99%')};
  transition: all 0.3s;
  transform: translate3d(0, ${props => (props.showAction ? '1rem' : '0')}, 0);
  ${props => props.showAction &&
    props.locking &&
    css `
      animation: ${ShadowAnim} 1.5s ease;
      animation-fill-mode: forwards;

      &::after {
        animation: ${ShadowAfterAnim(props)} ${props.showAction ? '1.5s' : 0}
          ease;
        animation-fill-mode: forwards;
      }
    `};
`;
const StyledFooter = styled.div `
  min-height: 1rem;
  width: 100%;
`;
const Actions = styled.span `
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const PreviewCardView = ({ 'data-trackingid': dataTrackingId, description = null, footer = null, header = null, isLocked = false, isSemanticLink = true, isShadowShown, linkFooter = null, media, shadowColor = undefined, shadowContent = null, title, to, isActionShown = isShadowShown, }) => {
    return (React.createElement(Card, null,
        React.createElement(PreviewCardInner, { "data-testid": "preview-card-inner", showAction: isActionShown, locking: isLocked },
            React.createElement(CardHeader, { "data-testid": "preview-card-header" }, header),
            React.createElement(CardLink, { to: to, "data-testid": "preview-card", "data-trackingid": dataTrackingId, media: media, title: title, description: description, linkFooter: linkFooter, isSemanticLink: isSemanticLink }),
            React.createElement(StyledFooter, { "data-testid": "preview-card-footer" }, footer)),
        isShadowShown && (React.createElement(React.Fragment, null,
            React.createElement(StyledShadow, { shadowColor: shadowColor, locking: isLocked, "data-testid": "preview-card-shadow" },
                React.createElement(Actions, { "data-testid": "preview-card-shadow-content" }, shadowContent)),
            React.createElement(ActionShadow, { shadowColor: shadowColor, shadowContent: shadowContent, showAction: isShadowShown, locking: isLocked })))));
};
